export default __webpack_public_path__ + "static/media/banner akash.17ae29d3.jpg";